import React, { ReactNode } from "react";
import { Tooltip, Statistic } from "antd";
import { OverviewCard } from "./OverviewCard";
import { Variant, Severity } from "./types";

// Map Severity to Variant
const severityToVariant = (severity?: Severity): Variant => {
  if (!severity) return "default";
  switch (severity) {
    case "critical":
      return "critical";
    case "warning":
      return "warning";
    case "info":
      return "default";
  }
};

interface CardWithHeaderProps {
  title: ReactNode;
  duration?: string;
  children: ReactNode;
  severity?: Severity;
  variant?: Variant;
  onClick?: () => void;
  hoverable?: boolean;
  className?: string;
}

export const CardWithHeader: React.FC<CardWithHeaderProps> = ({
  title,
  duration,
  children,
  severity,
  variant,
  onClick,
  hoverable = false,
  className = "",
}) => {
  // Use explicit variant if provided, otherwise map severity to variant, default to "default"
  const cardVariant: Variant =
    variant || (severity ? severityToVariant(severity) : "default");

  // Helper function to convert duration to tooltip text
  const getDurationTooltip = (dur: string): string => {
    if (dur === "24h") return "Last 24 hours";
    if (dur === "30d") return "Last 30 days";
    if (dur === "14d") return "Last 14 days";
    if (dur === "7d") return "Last 7 days";
    return dur;
  };

  return (
    <OverviewCard
      hoverable={hoverable || !!onClick}
      onClick={onClick}
      variant={cardVariant}
      className={`kpi-card ${className}`}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div style={{ flex: 1 }}>
          <Statistic title={title} value="" valueStyle={{ display: "none" }} />
        </div>
        {duration && (
          <Tooltip title={getDurationTooltip(duration)}>
            <span className="kpi-duration">{duration}</span>
          </Tooltip>
        )}
      </div>
      {children}
    </OverviewCard>
  );
};
